import { useEffect, useState } from 'react'

import { supabase } from '../services/supabaseClient'
// lazy memo do cacheService
let __cacheSvc: any;
async function getCacheService() {
  if (!__cacheSvc) {
    const mod = await import('../services/cacheService');
    __cacheSvc = mod.cacheService;
    try { await __cacheSvc.init?.(); } catch {}
  }
  return __cacheSvc;
}
import { offlineSyncService } from '../services/offilineSyncService'

import { User } from '@supabase/supabase-js'

// Singleton para controlar inicialização global
let authInitialized = false
let globalUser: User | null = null
let globalLoading = true
let authListeners: Array<(user: User | null, loading: boolean) => void> = []

// Função para notificar todos os listeners
const notifyListeners = () => {
  authListeners.forEach(listener => listener(globalUser, globalLoading))
}

// Função para inicializar auth uma única vez
const initializeAuth = async () => {
  if (authInitialized) return
  
  authInitialized = true
  console.log('🔐 useAuth: Inicializando verificação de sessão...')
  
  // Verificar sessão atual
  try {
    const { data: { session }, error } = await supabase.auth.getSession()
    console.log('🔐 useAuth: Sessão verificada:', { user: session?.user?.id, error })
    globalUser = session?.user ?? null
    globalLoading = false
    notifyListeners()
  } catch (error) {
    console.error('❌ useAuth: Erro ao verificar sessão:', error)
    globalUser = null
    globalLoading = false
    notifyListeners()
  }

  // Escutar mudanças de autenticação
  supabase.auth.onAuthStateChange((event, session) => {
    console.log('🔐 useAuth: Mudança de auth detectada:', { event, user: session?.user?.id })
    globalUser = session?.user ?? null
    globalLoading = false
    notifyListeners()
    
    if (!session?.user) {
      // logout: limpa caches e fila
      console.log('🔐 useAuth: Limpando caches após logout...')
      getCacheService().then(cs => {
        try {
          cs.forceUpdate()
          offlineSyncService.clearQueue?.()
        } catch (error) {
          console.error('❌ useAuth: Erro ao limpar caches:', error)
        }
      }).catch(err => {
        console.error('❌ useAuth: Erro ao obter cacheService:', err)
      })
    }
  })
}

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(globalUser)
  const [loading, setLoading] = useState<boolean>(globalLoading)

  useEffect(() => {
    // Inicializar auth se ainda não foi inicializado
    initializeAuth()
    
    // Adicionar listener
    const listener = (newUser: User | null, newLoading: boolean) => {
      setUser(newUser)
      setLoading(newLoading)
    }
    
    authListeners.push(listener)
    
    // Remover listener na limpeza
    return () => {
      authListeners = authListeners.filter(l => l !== listener)
    }
  }, [])

  return { user, loading }
}